function retrieveShowTotalSpace(companyId) {
    return window.tenantAxios.get(`/company/${companyId}/show-total-space`);
}

function updateShowTotalSpace(companyId, showTotalSpace) {
    return window.tenantAxios.patch(`/company/${companyId}/show-total-space`, showTotalSpace);
}

export default {
    retrieveShowTotalSpace,
    updateShowTotalSpace,
};
